import { isImageOr3dModel, processAttachment } from "@msys/ui";
import React from "react";
import { ClientInput } from "./types.js";

export function useClientInputAttachments(clientInput: ClientInput) {
  return React.useMemo(() => {
    const attachments = clientInput.attachments.map(attachment =>
      processAttachment({
        id: attachment.attachmentId,
        url: attachment.url,
        title: attachment.title,
        mimeType: attachment.mimeType,
      })
    );

    return {
      images: attachments.filter(isImageOr3dModel),
      files: attachments.filter(attachment => !isImageOr3dModel(attachment)),
    };
  }, [clientInput.attachments]);
}
